import React, { useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Modal from "../Modal";

const ModalEditarProspecto = ({ prospecto, cargarProspectos, cerrar }) => {
  const [form, setForm] = useState(prospecto);
  const { token } = useContext(AuthContext);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const actualizar = async () => {
    try {
      const res = await fetch(
        `/api/prospectos/${form.id_prospecto}`,
        {
          method: "PUT",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(form),
        }
      );

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Error al actualizar prospecto");
      }

      cargarProspectos();
      cerrar();
    } catch (error) {
      console.error("Error actualizando prospecto:", error);
      alert("No se pudo actualizar el prospecto. Revisa la consola.");
    }
  };

  const inputClass =
    "w-full border border-slate-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400";

  return (
    <Modal open={true} onClose={cerrar} title="Editar prospecto" maxWidth="max-w-lg">
      <div>
        <div className="space-y-3">
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Nombre</label>
            <input
              className={inputClass}
              name="nombre"
              value={form.nombre}
              onChange={handleChange}
              placeholder="Nombre"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Teléfono</label>
            <input
              className={inputClass}
              name="telefono"
              value={form.telefono}
              onChange={handleChange}
              placeholder="Teléfono"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Colonia</label>
            <input
              className={inputClass}
              name="colonia"
              value={form.colonia}
              onChange={handleChange}
              placeholder="Colonia"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Dirección</label>
            <input
              className={inputClass}
              name="direccion"
              value={form.direccion}
              onChange={handleChange}
              placeholder="Dirección"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 mt-4 pt-3 border-t border-slate-100">
          <button
            className="px-3.5 py-1.5 text-sm rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
            onClick={cerrar}
          >
            Cancelar
          </button>
          <button
            className="px-3.5 py-1.5 text-sm rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-medium transition"
            onClick={actualizar}
          >
            Guardar
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalEditarProspecto;